import gql from 'graphql-tag'

const query = gql`
query listProductListItems($filter: ProductListItemFilter) {
	cashAssist {
		listProductListItems(filter: $filter) {
			id
			productId
			productListId
			product {
				name
			}
		}
	}
}`

export default query
